// Copyright (c) 2017 Deere & Company

const machineStatusFilterOptions = [
    ['product', 'pin'],
    ['product', 'dealer', 'name'],
    ['product', 'dealer', 'location', 'city'],
    ['product', 'dealer', 'location', 'state'],
    ['product', 'dealer', 'account'],
    ['newStatus', 'value']
];

export default machineStatusFilterOptions;



// WEBPACK FOOTER //
// ./src/tcsm/wip/services/machine-status-filter-options.js